import { ProductImage } from './productService';

export const uploadCategoryList = async () => {
  const token = process.env.REACT_APP_BLOB_READ_WRITE_TOKEN;
  
  if (!token) {
    throw new Error('Blob token not found');
  }

  const categoryList = {
    categories: [
      {
        id: 'sneakers',
        name: '球鞋',
        description: '运动鞋和潮流球鞋',
        image: '/blob-api/products/categories/1-ltCpJXYCeWCQ2kCcAXuDcRbYorfRJq.jpg',
        order: 1
      },
      {
        id: 'clothing',
        name: '服饰',
        description: '潮流服装',
        image: '/blob-api/products/categories/1-ltCpJXYCeWCQ2kCcAXuDcRbYorfRJq.jpg',
        order: 2
      }
    ]
  };

  const blob = new Blob([JSON.stringify(categoryList, null, 2)], {
    type: 'application/json',
  });

  try {
    console.log('UploadService - Starting category list upload');
    
    const response = await fetch('/blob-api/products/categories/category-list.json', {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(categoryList),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('UploadService - Category list uploaded successfully:', result);
    return result.url;
  } catch (error) {
    console.error('UploadService - Error uploading category list:', error);
    throw error;
  }
};

// 上传商品图片
export const uploadProductImage = async (
  productId: string,
  file: File,
  type: 'main' | 'detail'
): Promise<ProductImage | null> => {
  try {
    const token = process.env.REACT_APP_BLOB_READ_WRITE_TOKEN;
    
    if (!token) {
      throw new Error('Blob token not found');
    }

    // 使用productId的时间戳部分作为文件名时间戳
    const timestamp = productId.split('-')[1] || Date.now();
    const fileName = `${type}-${timestamp}-${file.name}`;
    // 修改为使用正确的API路径
    const filePath = `products/images/${productId}/${fileName}`;

    console.log('UploadService - Uploading image:', filePath);

    // 上传图片
    const response = await fetch(`/blob-api/${filePath}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: file,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('UploadService - Image uploaded successfully:', result);

    // 返回图片信息
    return {
      url: result.url,
      type,
      alt: `${productId} - ${type} view`
    };
  } catch (error) {
    console.error('UploadService - Error uploading product image:', error);
    return null;
  }
}; 